import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';

import './Controls.css';
import {getNumberWithoutSpaces} from "../../../../../common/utils/format";
const Controls = ({ prev, next }) => {
  return (
    <div className="controls">
      {prev ? (
        <div className="control">
          <Button block size="large" className="controlBtn">
            <Link to={`/executorship/offer/${prev.id}`}>
              Предыдущее предложение
            </Link>
          </Button>
          <span className="sub">
            {getNumberWithoutSpaces(prev.info.offerNumber)}
          </span>
        </div>
      ) : null}
      {next ? (
        <div className="control">
          <Button block size="large" className="controlBtn">
            <Link to={`/executorship/offer/${next.id}`}>
              Следующее предложение
            </Link>
          </Button>
          <span className="sub">
            {getNumberWithoutSpaces(next.info.offerNumber)}
          </span>
        </div>
      ) : null}
    </div>
  );
};
export default Controls;
